import { HandlersStack } from '../../generic/utils';

import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('baseUrl', { startValue: undefined })
  .addVariable('vinculationsTokens', { startValue: {} })
  .addVariable('errorHandlers', { startValue: new HandlersStack<any>() })
  .addVariable('token', { startValue: undefined });
